<!-- TODO: Need Refactoring  -->
<app-header-container bgColor="white" headerTitle="Distribution Management" [releasesList]="releasesList" buttonTitle="Upload APK" [isShowButton]="releasesList.length > 0"
    (onButtonClick)="onCreateRelease()"></app-header-container>
<div class="container">
    <div></div>

    <div>
        <div class="feature-intro-general-wrapper">
            <div class="content-center" *ngIf="releasesList?.length === 0 && !commonService.isLoading">
                <div class="hello-icon"></div>
                <div class="feature-heading">
                    Welcome to <br />
                    Fusion Distribution Management
                </div> <br>
                <p class="feature-description">
                    Fusion allows you to distribute your releases by uploading an APK file
                    on the dashboard provided to you.
                </p> <br />
                <button class="btn-secandry" (click)="onCreateRelease()">
                    Get Started
                </button>
            </div>

            <!-- <div *ngIf="releasesList?.length > 0">
                <div class="main-list" #listContainer (scroll)="onScroll($event)">
                    <div class="list-container">
                        <div class="list-headers">
                            <div class="list-header-content-container">RELEASES</div>
                            <div class="list-header-content-container">UPLOADED ON</div>
                            <div class="list-header-content-container">INVITED TESTERS</div>
                            <div class="list-header-content-container">DOWNLOADS</div>

                            
                        </div>

                        <div class="list-tile" (click)="showDetails(item)" *ngFor="let item of releasesList">
                            <div class="list-tile-data">
                                <div class="list-tile-data-text polar">
                                    {{ item.releaseKuid }}
                                </div>
                            </div>
                            <div class="list-tile-data">
                                <div class="list-tile-data-text">
                                    <app-time-stamp-conversion [utcTime]="item.uploadedOn"></app-time-stamp-conversion>
                                </div>
                            </div>
                            <div class="list-tile-data1">
                                <div class="list-tile-data-text1">{{ item.testers }}</div>
                            </div>
                            <div class="list-tile-data">
                                <div class="list-tile-data-text1" *ngIf="item.downloadCount !== null">
                                    {{ item.downloadCount }}
                                </div>
                                <div class="list-tile-data-text1" *ngIf="item.downloadCount === null">
                                    0
                                </div>
                            </div>

                            <div class="right-icon-container" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                                <div class="list-tile-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                        <g fill="none" fill-rule="evenodd">
                                            <path d="M0 0h16v16H0z" />
                                            <path
                                                d="M4 9.333c-.367 0-.68-.13-.941-.392A1.282 1.282 0 0 1 2.667 8c0-.367.13-.68.392-.942.26-.26.574-.391.941-.391s.68.13.941.391c.262.261.392.575.392.942s-.13.68-.392.941c-.26.262-.574.392-.941.392zm4 0c-.367 0-.68-.13-.941-.392A1.282 1.282 0 0 1 6.667 8c0-.367.13-.68.392-.942.26-.26.574-.391.941-.391s.68.13.942.391c.26.261.391.575.391.942s-.13.68-.391.941A1.284 1.284 0 0 1 8 9.333zm4 0c-.367 0-.68-.13-.942-.392A1.283 1.283 0 0 1 10.667 8c0-.367.13-.68.391-.942.261-.26.575-.391.942-.391s.68.13.942.391c.26.261.391.575.391.942s-.13.68-.391.941a1.284 1.284 0 0 1-.942.392z"
                                                fill="#000" fill-rule="nonzero" />
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <mat-menu #menu="matMenu">
                                <div class="title" mat-menu-item (click)="deleteApk(item.releaseKuid)">
                                    <img src="../../../../../../assets/icons/icons-details.svg" />
                                    <div class="menu-title">Delete Apk</div>
                                </div>
                            </mat-menu>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="review-list-header" *ngIf="releasesList?.length >  0 && !commonService.isLoading">
                <div class="list-view-col responder-col">RELEASES</div>
                <div class="list-view-col rating-col">UPLOADED ON</div>
                <div class="list-view-col type-col">INVITED TESTERS</div>
                <!-- <div class="list-view-col version-col">DOWNLOADS</div> -->
                <div class="list-view-col activate-col"></div>
            </div>
            <div class="review-list-row" *ngFor="
                  let item of releasesList | paginate
          : {
           
              itemsPerPage: pageSize,
              currentPage: currentPage,
              totalItems: totalReleaseRecords
            }; let i=index">
                <div class="responder-col-row">
                    <div class="version-history-text clr-303030 fw-500">
                        {{ item?.releaseKuid }}
                    </div>

                </div>
                <div class="type-col-row">
                    <div class=" fs-15 clr-4f4f4f"> <app-time-stamp-conversion [utcTime]="item?.uploadedOn"></app-time-stamp-conversion></div>
                </div>
                <div class="type-col-row">
                    <div class=" fs-15 clr-4f4f4f">{{ item?.testers }}</div>
                </div>
                <!-- <div class="type-col-row">
                    <div class=" fs-15 clr-4f4f4f">{{ item?.downloadCount === null ? '0': item?.downloadCount }}</div>
                </div> -->


                <div class="activate-col-row">
                    <div class="view" (click)="showDetails(item)">
                        <svg class="icon view-icon">
                            <use xlink:href="../../../assets/bug-journey-icons.svg#View"></use>
                        </svg>
                    </div>
                    <div class="option">
                        <svg width="16px" height="16px" class="icon option-icon" (click)="toggleMenu(i)">
                            <use _ngcontent-xtk-c384="" xlink:href="../../../../../../assets/icon-sprite.svg#inactive-Options"></use>
                        </svg>
                        <div class="deactivate-button" *ngIf="openMenuIndex === i" (click)="deleteApk(item.releaseKuid)">
                            <div class="button-wrapper">
                                <svg class="icon">
                                    <use xlink:href="../../../../../../../assets/bug-journey-icons.svg#Delete"></use>
                                </svg>
                                <div>Delete APK</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="divider-list-overflow" *ngIf="releasesList.length == 0">
                <div class="state-1">
                    <p class="fs-15 clr-4f4f4f fw-400">
                        <img _ngcontent-ynm-c384="" src="../../../../../../../assets/icons/caution.svg" class="caution-icon" />
                        No data found. Please add new entries to get started.

                    </p>
                </div>
            </div> -->
        </div>
        <div class="pagination-wrapper">
            <!-- <pagination-controls *ngIf="filteredReleaseList?.length > 0" class="fw-500 f-15 mt-18" previousLabel="<" nextLabel=">"
                            (pageChange)="onPageChange($event)"></pagination-controls> -->

            <app-custom-pagination id="list2" *ngIf="releasesList?.length > 0" (pageChange)="onPageChnaged($event)" [itemsPerPage]="pageSize"
                [totalItems]="totalReleaseRecords"></app-custom-pagination>
        </div>
    </div>
</div>

<!-- Dialog to create Test Run -->
<div class="show-dialog-container" [ngClass]="{ active: isShowRelease }">
    <!-- Content container inside the dialog container -->
    <div class="content-container">
        <!-- Inner contianer inside of the content container  -->
        <div class="container-inner">
            <!-- Top container to show heading and close button to close container -->
            <div class="top-container">
                <!-- Dialog heading container  -->
                <div>
                    <!-- Dialog header  -->
                    <div class="heading">New Release</div>
                    <!-- Dialog description -->
                    <div class="Lorem-ipsum-dolor-si">
                        Upload new release verision and share it with a user group
                    </div>
                </div>
                <!-- Button to close container  -->
                <div class="cancel-container" (click)="closeModal()">X</div>
            </div>

            <div class="dot-container" (click)="file.click()" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
                <input class="file-input" type="file" accept=".apk" (change)="upload($event)" #file />
                <img class="fil" src="../../../../../../assets/icons/ic-outline-file-upload-dis.svg" />
                <div class="Drag">
                    Drag & Drop or <span class="Upload">Upload</span>
                </div>
                <div class="file">{{ selectedFile?.name }}</div>
            </div>
            <div class="top-container">
                <!-- Dialog heading container  -->
                <div>
                    <!-- Dialog header  -->
                    <div class="heading">Add Release Notes</div>

                    <quill-editor [modules]="quillModules" class="editor" [(ngModel)]="releaseNotes"></quill-editor>
                </div>
            </div>
        </div>
        <div class="apk-error" *ngIf="apkError">Please attach .APK file</div>

        <!-- Progress bar to show upload progress -->
        <div class="progress-wrapper" *ngIf="showUploadValue || showMessage">
            <div class="progress-container">
                <span class="bold" *ngIf="showUploadValue">{{ uploadPercentage }}%</span>
                <span class="bold" *ngIf="showMessage">{{
                    showVerifyUploadMessage
                    }}</span>
            </div>
        </div>

        <!-- Bottom contianer to show create button -->
        <div class="bottom-container">
            <!-- Empty container to show button on right side  -->
            <div></div>
            <!-- Create Test Run Button -->
            <button class="delete-btn" (click)="uploadFile()">Create</button>
        </div>
    </div>
</div>